<template>
  <v-navigation-drawer
    v-model="drawer"
    class="dental-nav primaryColor elevation-3"
    app
  >
    <v-list color="#f5f5f5">
      <v-list-item>
        <v-img
          max-width="150"
          style="margin: auto"
          sizes="100"
          src="@/assets/logo.png"
        ></v-img>
      </v-list-item>
    </v-list>

    <v-list class="pa-0">
      <v-list-item-group v-model="model">
        <SNavbarLink v-for="link in links" :key="link.icon" :link="link" />
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import appRoute from "@/router/routes";

export default {
  name: "SNavbar",
  props: ["drawer"],
  data: () => ({
    links: appRoute,
    model: null,
  }),
};
</script>

<style>
.dental-nav {
  background-image: linear-gradient(to bottom, #00ACB1, #014749bd),
    url("~@/assets/background.jpg") !important;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
</style>
